import type { Document } from "@repo/types";
import { AgendaItemDisplay } from "../agendaItems/AgendaItemDisplay";

export const DocumentParents = ({
  tenantId,
  document,
}: {
  tenantId: string;
  document: Document;
}) => {
  return (
    <div className="p-2">
      <h1 className="text-2xl">Agenda Items Used On</h1>
      <div className="flex flex-col pt-4">
        {document.parentIds?.map((agendaItemId) => (
          <AgendaItemDisplay
            key={agendaItemId}
            agendaItemId={agendaItemId}
            tenantId={tenantId}
          />
        ))}
      </div>
    </div>
  );
};
